import { Navigate, useLocation } from 'react-router-dom';
import { AppShell } from '@/chrome/AppShell';
import { useMe } from '@/hooks/useMe';

// Layout-level route guard: redirect to /login when /me probe returns null,
// otherwise render the app shell (which provides <Outlet /> for child routes).
export default function RequireAuth() {
  const location = useLocation();
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--apm-muted)',
          fontSize: 13,
        }}
      >
        Loading…
      </div>
    );
  }

  if (!me) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <AppShell me={me} />;
}
